import { actionTypes } from './actions';

const initialState = {
  list: {
    loading: false,
    list: [],
    params: {},
    count: 0
  },
  one: {
    loading: false,
    data: null
  }
};

const OrdersHistoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_LIST: {
      const { payload = {} } = action;
      const { list = {} } = state;
      return {
        ...state,
        list: {
          ...list,
          ...payload
        }
      };
    }
    case actionTypes.GET_ONE: {
      const { one = {} } = state;
      const { payload = {} } = action;
      return {
        ...state,
        one: {
          ...one,
          ...payload
        }
      };
    }
    default:
      return state;
  }
};

export default OrdersHistoryReducer;
